export default __webpack_public_path__ + "static/ico-numerique-1-ce7e620ca4a209324c5262b2a7525f66.svg";